export default __webpack_public_path__ + "static/media/peso_Focus.1f329e17.svg";